module.exports = __webpack_public_path__ + "img/cover-bg.b9f2d08.webp";